import { render, staticRenderFns } from "./CacheSetting.vue?vue&type=template&id=7489a736&scoped=true&"
import script from "./CacheSetting.vue?vue&type=script&lang=js&"
export * from "./CacheSetting.vue?vue&type=script&lang=js&"
import style0 from "./CacheSetting.vue?vue&type=style&index=0&id=7489a736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7489a736",
  null
  
)

export default component.exports